// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__zjiPx","buttons":"RemoveExpirationActionButtons_buttons__2pRHF"};